import { render, staticRenderFns } from "./trainingModulePageNew5.vue?vue&type=template&id=117f70fc&scoped=true&"
import script from "./trainingModulePageNew5.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew5.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew5.vue?vue&type=style&index=0&id=117f70fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f70fc",
  null
  
)

export default component.exports